import { CURRENCY } from '@repo/shared/constants';
import { providerPreLimitValues } from './provider-pre-limit-values';
import { providerLimitValues } from './provider-limit-values';
export var getMaxAvailableAmountAndCurrency = function (merchantResponseData, provider) {
    if (merchantResponseData && provider) {
        var limitValues = providerLimitValues(merchantResponseData, provider);
        if (!limitValues) {
            var preLimitValues = providerPreLimitValues(merchantResponseData, provider);
            return {
                max: (preLimitValues === null || preLimitValues === void 0 ? void 0 : preLimitValues.max) || 0,
                currency: (preLimitValues === null || preLimitValues === void 0 ? void 0 : preLimitValues.currency) || CURRENCY,
            };
        }
        return {
            max: (limitValues === null || limitValues === void 0 ? void 0 : limitValues.available) || 0,
            currency: (limitValues === null || limitValues === void 0 ? void 0 : limitValues.currency) || CURRENCY,
        };
    }
};
